/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, {
    useRef, useEffect, useState, useContext,
} from 'react';
import QueryString from 'qs';
import { connect, useSelector, useDispatch } from 'react-redux';
import {
    object, string, shape, func, number, bool, array,
} from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useUIDSeed } from 'react-uid';
import { withRouter } from 'react-router-dom';
import Media from 'react-media';
import { actions as tagManagerActions } from '../../../../../../state/ducks/TagManager';
import GraphqlClubSelection from '../GraphqlClubSelection/GraphqlClubSelection';
import RedirectToSku from '../common/RedirectToSku';
import FoodRadioLabelContainer from './FoodRadioLabelContainer';
import { productType as productPropType, selectedSkuType, skuDataType } from '../common/types';
import FloralRadioLabelContainer from './Partials/FloralRadioLabelContainer';
import { getBrand, getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getActiveABTest, getActiveABTests } from '../../../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import { getEnterpriseId } from '../../../../../../state/ducks/Member/ducks/EnterpriseId/EnterpriseId-Selectors';
import DynamicPrice from './DynamicPrice';
import { getIsBot, getUserSubmittedProductFilterZipcode } from '../../../../../../state/ducks/App/App-Selectors';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import FoodConfigurator from './FoodConfigurator';
import KlarnaCreditPromotionBadge from '../../../../Checkout/KlarnaPaymentOnSiteMessage/KlarnaCreditPromotionBadge/KlarnaCreditPromotionBadge';
import FloralDropDownContainer from './Partials/FloralDropDownContainer';
import ProductPriceName from './ProductPriceName';
import Upsells from './Upsells';
import useIsPlaPage from '../../../../../helpers/hooks/useIsPlaPage';
import ProductNameRender from '../common/ProductNameRender/index';
import getPrice from '../../../../../helpers/getPrice/getPrice';
import DynamicPriceSkeleton from '../../../GraphqlSkeletonComponents/DynamicPriceSkeleton';
import SelectedGiftSize from '../GraphqlCustomProductPage/GraphqlCYOProductPage/BYOProductPage/SelectedGiftSize';
import PriceBreakDownUi from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceBreakDownUi';
import { getIsAuthenticatedStatus, getIsPassportUserLoggedIn } from '../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getPassportData } from '../../../../../../state/ducks/Passport/Passport-Selectors';
import validatePassport from '../../../../../helpers/validatePassport';
import { getPassportSubscriptionStatus } from '../../../../../../state/ducks/Common/Common-Selectors';
import { getBaseCode } from '../../../../../helpers/tracking/product/dataLayerProductHelpers';
import YotpoProductReview from '../YotpoProductReview';
import ProductReview from '../ProductReview';
import PDPSkuSelector from './PDPSkuSelector';
import SKUSelectorSkeleton from '../../../GraphqlSkeletonComponents/SKUSelectorSkeleton';
import PriceBreakDownContext from '../../../GraphqlCoreBrowsing/PriceBreakDownContext';
import CaPriceVariant from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/CaPriceTestType';
import { setCaCampaign } from '../../../../../../state/ducks/App/App-Actions';

const CommonRadioGroup = ({
    classes,
    trackEvent,
    skuData,
    handleSkuChange,
    selectedSku,
    presentation_family,
    customizedRadio, // (pass customizedRadio as paramter if you want to use customized radio button,
    // dont pass customizedRadio as parameter if you want to use normal radio button.)
    productType,
    renderSkuPrice,
    skuMonths,
    changeClubMonth,
    changeClubLength,
    clubUpsells,
    selectedClubUpsells,
    changeClubUpsell,
    parentPartNumber,
    baseProductSku,
    isPassportBundleProduct,
    product,
    location,
    productUrl,
    brand,
    isPdpYotpoEnabled,
    activeABTests,
    enterpriseId,
    isBot,
    floralPLARedesign,
    ssrDeviceType,
    upsellRedesign,
    productNameRender,
    showSkuOnMobile,
    clubComponents,
    isSkuShown,
    userSubmittedProductFilterZipcode,
    isDynamicPrice,
    setShippingModalOpen,
    isClubPDPV2,
    isCyoProduct,
    isPdpRedesignEnabled,
    isPdpRedesignSkuEnabled,
    isPlaRedesignEnabled,
    hideUpsells,
    hidePrice,
    isPlaRedesignVariantB,
}) => {
    const { featureFlags = {}, presentation_family: productPresentationFamily = '' } = useContext(CrossMerch);
    const priceBreakDownContext = useContext(PriceBreakDownContext);
    const caTotalPriceTest = priceBreakDownContext?.priceBreakDownABTest?.toLowerCase() === 'test';
    const seed = useUIDSeed();
    const [dynamicPriceIsLoading, setDynamicPriceLoading] = useState(true);
    const [productSkuPrices, setProductSkuPrices] = useState([]);
    const [productSkuResponse, setProductSkuResponse] = useState([]);
    const [priceRule, setPriceRule] = useState(null);
    const isFoodBrand = ((productPresentationFamily || presentation_family) === 'food');
    const isPassportUser = useSelector(getIsPassportUserLoggedIn);
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const passportData = useSelector(getPassportData);
    const isPassportMember = validatePassport('isActivePassportUser', passportData);
    const isPassportAdded = useSelector(getPassportSubscriptionStatus);
    const [isCaDelivery, setIsCaDelivery] = useState(false);
    const dispatch = useDispatch();
    let variantList = [];
    if ((isPassportMember && isPassportUser) || isPassportAdded) {
        variantList = [{
            name: 'CUSTOMER_TYPE',
            value: 'Passport',
        }];
    } else if (isAuthenticated) {
        variantList = [{
            name: 'CUSTOMER_TYPE',
            value: 'Registered',
        }];
    }
    const tracker = (sku) => {
        trackEvent({
            eventCategory: 'Product Page',
            eventAction: 'Size Selection',
            eventLabel: sku.name,
            item_variant: selectedSku?.id || '',
        });
    };
    const searchTerms = QueryString.parse(location.search.replace(/^\?/, ''));
    const isSubscriptionSku = (selectedSku?.subscriptionsList?.type?.length > 0);
    const hasSubscriptionParam = searchTerms?.subscription?.toLowerCase && searchTerms.subscription.toLowerCase() === 'basic';

    const isSubscriptionV2Price = featureFlags['is-pdp-subscription-enabled'] && isSubscriptionSku;

    const isPlaPage = useIsPlaPage();
    const PLARedesignVariant = isPlaPage && ssrDeviceType === 'mobile';
    const foodPlaRedesign = useSelector(getFeatureFlag('which-food-pla-design'));
    const byoPdpEnabled = useSelector(getFeatureFlag('is-byo-pdp-enabled'));
    const experimentByoRedesign = useSelector(getFeatureFlag('experiment-byo-redesign'));
    const ccoOptimize = useSelector(getActiveABTest('cco_pdp_configurator'));
    const isPlaFood = featureFlags['is-simplified-pdp'] && isPlaPage && foodPlaRedesign === 'variant';
    // declaring Dynamic price call instance
    const dynamicPriceInstance = new DynamicPrice(skuData, enterpriseId, isSubscriptionSku && hasSubscriptionParam, selectedSku?.subscriptionsList?.type?.[0] || '', featureFlags['is-price-engine-batching-enabled'], variantList);
    const {
        getPriceRules, getRetailPrice, getSalePrice, getRetailDisplayPrice,
    } = dynamicPriceInstance;
    if (productType?.toLowerCase() === 'club') {
        return (
            <GraphqlClubSelection
                skuData={skuData}
                changeClubLength={changeClubLength}
                clubUpsells={clubUpsells}
                selectedSku={selectedSku}
                tracker={tracker}
                changeClubMonth={changeClubMonth}
                skuMonths={skuMonths}
                renderSkuPrice={renderSkuPrice}
                selectedClubUpsells={selectedClubUpsells}
                changeClubUpsell={changeClubUpsell}
                clubComponents={clubComponents}
                featureFlags={featureFlags}
                setShippingModalOpen={setShippingModalOpen}
                isClubPDPV2={isClubPDPV2}
                product={product}
            />
        );
    }
    // skuData is already sorted from parent components
    let skuDataList = skuData;
    if (baseProductSku) {
        const parentSkuIndex = skuDataList.findIndex((sku) => sku?.id === parentPartNumber);
        const parentSku = skuDataList.filter((sku) => sku?.id === parentPartNumber);
        if (parentSkuIndex) {
            const skuList = skuDataList.filter((sku) => sku.id !== parentPartNumber);
            skuDataList = [...parentSku, ...skuList];
        }
    }
    let skus = skuDataList;
    let upsells = [];
    if (upsellRedesign) {
        skus = skuDataList.filter((sku) => sku.__typename === 'ProductSku');
        upsells = skuDataList.filter((sku) => sku.__typename === 'Upsell');
    }
    const fptSkuUpsellMessage = activeABTests?.fpt_upsell_message_enabled === 'VARIANT';
    const gptSkuUpsellMessage = activeABTests?.gpt_upsell_message_enabled === 'VARIANT';
    const isUpsellMessageEnabledGPT = product?.availability?.productDeliveryType === 'GPT' && featureFlags['is-gpt-upsell-enabled'] && gptSkuUpsellMessage;
    const isUpsellMessageEnabledFPT = product?.availability?.productDeliveryType === 'FPT' && featureFlags['is-fpt-upsell-enabled'] && fptSkuUpsellMessage;
    const isUpsellFlagAndABTestEnabled = isUpsellMessageEnabledGPT || isUpsellMessageEnabledFPT;
    const [showUpsellMessage, setShowUpsellMessage] = React.useState(false);
    const showFptUpsellTimer = useRef();
    const dropDownBrand = product?.brandId === '1026' || product?.brandId === '1027';
    const isZipDynamicPricingEnabled  = featureFlags['is-zip-dynamic-pricing-enabled'];
    const isDynamicPricingEnabled =  featureFlags['is-dynamic-pricing-enabled'];

    const skuSortedByPrice = [...skus].sort((a, b) => getPrice(a.prices).value - getPrice(b.prices).value);
    const selectedSkuIndex = skuSortedByPrice.findIndex((sortedSku) => sortedSku.id === selectedSku.id);
    const largestSkuByPriceIndex = skuSortedByPrice.length - 1;
    let upsellSkuIndex = 0;
    if (largestSkuByPriceIndex !== selectedSkuIndex) {
        skuSortedByPrice.forEach((sku, index) => {
            if (getPrice(sku?.prices)?.value === getPrice(selectedSku?.prices)?.value) {
                upsellSkuIndex = index + 1;
            }
        });
    }
    useEffect(() => {
        if (productSkuPrices?.length > 0 && caTotalPriceTest) {
            const dynamicPrice = productSkuPrices.length > 0 ? productSkuPrices.find((item) => selectedSku.id === item.id) : null;
            handleSkuChange('', '', dynamicPrice);
        }
    }, [productSkuPrices, caTotalPriceTest]);

    // handle product selection
    const selectProduct = (e) => {
        let selectedSkuDynamicRuleId = null;
        const dynamicPrice = productSkuPrices.length > 0 ? productSkuPrices.find((item) => e.target.value === item.id) : null;
        if (productSkuPrices.length > 0) {
            const productSelected = productSkuPrices.filter((productDetails) => productDetails.id === selectedSku.id);
            selectedSkuDynamicRuleId = productSelected?.[0]?.priceRules;
        }

        handleSkuChange(e, selectedSkuDynamicRuleId, dynamicPrice);
    };

    useEffect(() => {
        // GA tracking
        if (!upsellRedesign) {
            const upsellData = (skuDataList || []).filter((sku) => sku.__typename === 'Upsell') || [];
            const upsellList = (upsellData || []).map((item) => item.id);
            const eventParam = {
                eventCategory: 'PDP Upsell',
                eventAction: `Default Upsell | ${selectedSku?.id} | Demand Type UP`,
                eventLabel: `Upsells ${upsellList?.join?.(',')}`,
            };
            trackEvent(eventParam);
        }
    }, []);

    useEffect(() => {
        if (isSubscriptionV2Price) {
            // eslint-disable-next-line no-param-reassign
            selectedSku.priceRules = priceRule;
        }
    }, [selectedSku?.id]);

    useEffect(() => {
        if (isSubscriptionV2Price && !hasSubscriptionParam) {
            /**
             * Cleaning up priceRules is user unchecked the checkbox
             */
            // eslint-disable-next-line no-param-reassign
            selectedSku.priceRules = null;
            (skuDataList).forEach((sku) => {
                // eslint-disable-next-line no-param-reassign
                sku.priceRules = null;
            });
            setPriceRule(null);
            setProductSkuPrices([]);
        }

        if (isSubscriptionV2Price && hasSubscriptionParam) {
            setDynamicPriceLoading(true);
            dynamicPriceInstance.call(isZipDynamicPricingEnabled, userSubmittedProductFilterZipcode).then((productPrices) => {
                const priceRules = getPriceRules(selectedSku?.id);
                // eslint-disable-next-line no-param-reassign
                selectedSku.priceRules = priceRules;
                setPriceRule(priceRules);
                setProductSkuPrices(productPrices?.newPrices || []);
                setProductSkuResponse(productPrices?.newPrices || []);
                setIsCaDelivery(CaPriceVariant(productPrices));
                dispatch(setCaCampaign(productPrices));
                setDynamicPriceLoading(false);
            }).catch(() => {
                setDynamicPriceLoading(false);
            });
        }
    }, [isSubscriptionV2Price, featureFlags, isSubscriptionSku, hasSubscriptionParam, userSubmittedProductFilterZipcode]);

    useEffect(() => {
        if (hasSubscriptionParam && isSubscriptionV2Price) {
            setDynamicPriceLoading(false);
            return;
        }
        if (hasSubscriptionParam) {
            setDynamicPriceLoading(false);
            return;
        }
        if (isBot || !isDynamicPricingEnabled) {
            setDynamicPriceLoading(false);
            return;
        }
        if (enterpriseId) {
            setDynamicPriceLoading(true);
            dynamicPriceInstance.call(isZipDynamicPricingEnabled, userSubmittedProductFilterZipcode).then((productPrices) => {
                const priceRules = getPriceRules(selectedSku?.id);
                // eslint-disable-next-line no-param-reassign
                selectedSku.priceRules = priceRules;
                setPriceRule(priceRules);
                setProductSkuPrices(productPrices?.newPrices || []);
                setProductSkuResponse(productPrices?.newPrices || []);
                setIsCaDelivery(CaPriceVariant(productPrices));
                dispatch(setCaCampaign(productPrices));
                setDynamicPriceLoading(false);
            }).catch(() => {
                setDynamicPriceLoading(false);
            });
        }
    }, [
        setDynamicPriceLoading,
        setProductSkuPrices,
        featureFlags,
        isSubscriptionV2Price,
        hasSubscriptionParam,
        userSubmittedProductFilterZipcode,
        enterpriseId,
        isPassportAdded,
    ]);

    useEffect(() => {
        // eslint-disable-next-line no-param-reassign
        selectedSku.priceRules = null;
        if (productSkuResponse?.length > 0) {
            const productSelected = (productSkuResponse || []).filter((productDetails) => productDetails?.id === selectedSku?.id);
            // eslint-disable-next-line no-param-reassign
            selectedSku.priceRules = productSelected?.[0]?.priceRules || priceRule;
        }
    }, [selectedSku?.id, productSkuResponse?.length > 0]);

    useEffect(() => {
        /**
         * This will wait for 1.5s before showing the upsell Message
         * This will add the click event listener to the document to hide the upsell message on click
         * This will be repeated if the selectedSku is changed
         */
        if (isUpsellFlagAndABTestEnabled && !isFoodBrand && typeof document !== 'undefined') {
            if (showFptUpsellTimer.current) clearTimeout(showFptUpsellTimer);
            showFptUpsellTimer.current = setTimeout(() => setShowUpsellMessage(true), 1500);
        }

        return () => {
            setShowUpsellMessage(false);
        };
    }, [selectedSku.id]);

    if (dynamicPriceIsLoading && isDynamicPrice) {
        if (skus.length > 1 && presentation_family === 'food' && isPdpRedesignSkuEnabled) {
            return <SKUSelectorSkeleton skus={skus} />;
        }
        return <DynamicPriceSkeleton isPdpRedesignEnabled={isPdpRedesignEnabled} />;
    }

    const attributesWatchList = {
        count: [],
        net_weight: [],
        quality_grade: [],
        wine_beer_type: [],
    };

    Object.freeze(attributesWatchList); // to avoid updating the object

    const syAttributes = { ...attributesWatchList }; // copy of object
    const skuAttributes = { ...attributesWatchList };// copy of object

    const attributesList = Object.keys({ ...attributesWatchList });

    const ConfiguratorBrands = ['VC'];  // logic to enable configurator view without optimize script
    const isBrand = ConfiguratorBrands.includes(brand.code) && product?.categories.includes('vc');

    const isCherylsOptimizeEnabled = brand?.code === 'CCO' ? ccoOptimize === 'variant' : true;

    const isSyConfigurator = (featureFlags['sy-pdp-redesign'] || isBrand) && isCherylsOptimizeEnabled;

    const skuSpecific = [];
    if (isSyConfigurator) {
        (product?.attributes || []).forEach((attribute) => {
            if (attributesList.includes(attribute?.name)) {
                syAttributes[attribute.name].push(attribute?.values?.[0]?.value);
            }
        });

        (product?.productSkus || []).forEach((sku) => {
            const attr = { ...attributesWatchList, sku: sku?.id };

            Object.keys({ ...attributesWatchList }).forEach((item) => {
                attr[item] = (sku?.attributes || []).find?.((attribute) => attribute?.name === item)?.values?.[0]?.value || '';
            });

            (sku?.attributes || []).forEach((attribute) => {
                if (attributesList.includes(attribute?.name) && !skuAttributes[attribute.name]?.includes?.(attribute?.values?.[0]?.value)) {
                    skuAttributes[attribute.name].push(attribute?.values?.[0]?.value);
                }
            });
            skuSpecific.push(attr);
        });
    }

    let priceDetails = [];
    const dynamicPriceList = (sku) => {
        if ((isSubscriptionV2Price || isDynamicPricingEnabled || isZipDynamicPricingEnabled) && productSkuPrices.length > 0) {
            const skuItemPriceList = (productSkuPrices || []).find((skuItem) => skuItem?.id === sku?.id)?.prices || [];
            const currentPriceList = JSON.parse(JSON.stringify(sku?.prices || []));
            priceDetails = currentPriceList.map((price) => {
                /**
         * Retail price update for standard products by dynamic price API, not updating for subscription products
         */
                if (price.type === 'retail' && skuItemPriceList.length > 0 && getRetailPrice(skuItemPriceList) && !(hasSubscriptionParam && !isDynamicPricingEnabled)) {
                    const retailPrice = getRetailPrice(skuItemPriceList);
                    const salePrice = getSalePrice(skuItemPriceList);
                    // eslint-disable-next-line no-param-reassign
                    price.value = retailPrice;
                    if ((retailPrice === salePrice) || retailPrice > salePrice) {
                        // eslint-disable-next-line no-param-reassign
                        price.value = getRetailDisplayPrice(skuItemPriceList);
                    }
                }

                /**
     * Used to get what would be the retail dynamic price to show as comparison to discounted subscription price
     */
                if (price.type === 'retail' && skuItemPriceList.length > 0 && getRetailDisplayPrice(skuItemPriceList) && (hasSubscriptionParam && isDynamicPricingEnabled)) {
                    // eslint-disable-next-line no-param-reassign
                    price.value = getRetailDisplayPrice(skuItemPriceList);
                }
                /**
     * Sale price update for standard products and subscription products by dynamic price API
     */
                if (price.type === 'sale' && skuItemPriceList.length > 0 && (isDynamicPricingEnabled || isZipDynamicPricingEnabled || hasSubscriptionParam) && getSalePrice(skuItemPriceList)) {
                    // eslint-disable-next-line no-param-reassign
                    price.value = getSalePrice(skuItemPriceList);
                }
                return price;
            });
            if (selectedSku?.id === sku?.id && isFoodBrand) {
                if (!productNameRender) {
                    // eslint-disable-next-line no-param-reassign
                    selectedSku.prices = priceDetails;
                }
                // eslint-disable-next-line no-param-reassign
                selectedSku.priceRules = priceRule;
            }
        }
        return priceDetails;
    };
    const getRadioButtons = () => (
        <RadioGroup
            data-testid={`${presentation_family}-skus`}
            name="skus"
            aria-label={`${presentation_family}-skus`}
            role="region"
            onChange={customizedRadio ? selectProduct : null}
            value={customizedRadio ? selectedSku.id : null}
            className={`${PLARedesignVariant && classes.customizeRadioContainer} ${ isPdpRedesignEnabled ? classes.pdpCustomRadio : ''}`}
        >
            {(skus).map((sku) => {
                // ABTEST remove if no longer neeeded
                // if fpt product, and ab test is enabled, and the sku price is $39.99 hide entire sku from being rendered
                if (product.availability.productDeliveryType === 'FPT'
                    && activeABTests?.hideSpecificSku
                    && sku.prices.some((priceObj) => priceObj.value === activeABTests?.value)) {
                    return null;
                }

                const PLACheckboxDesign = selectedSku?.id === sku?.id && PLARedesignVariant;

                const currentSkuIndexFromSortedSku = skuSortedByPrice.findIndex((sortedSku) => sortedSku?.id === sku?.id);
                const isCurrentSkuAsUpsell = selectedSkuIndex !== largestSkuByPriceIndex && currentSkuIndexFromSortedSku === upsellSkuIndex;

                let priceDifferenceBetweenSkuAndUpsell = 0;
                if (skuSortedByPrice[upsellSkuIndex]?.prices && skuSortedByPrice[selectedSkuIndex]?.prices) {
                    priceDifferenceBetweenSkuAndUpsell = (getPrice(skuSortedByPrice[upsellSkuIndex].prices)?.value - getPrice(skuSortedByPrice[selectedSkuIndex].prices)?.value) || 0;
                }

                /**
                     * Dynamic price call - price list handling updating the retail price and pass it in new list.
                 */
                const pricesList = dynamicPriceList(sku);
                return (
                    <RedirectToSku
                        selectedSkuId={selectedSku?.id}
                        onChange={selectProduct}
                        key={seed(sku)}
                    >
                        {({ redirectToSku }) => (
                            <FormControlLabel
                                key={seed(sku)}
                                className={`${isPdpRedesignEnabled ? classes.labelContainer : ''} ${showUpsellMessage && isCurrentSkuAsUpsell && isUpsellFlagAndABTestEnabled && (priceDifferenceBetweenSkuAndUpsell > 0) ? classes.upSellMessgaeRadioButton : classes.radioButton} ${PLARedesignVariant ? classes.customSelectedVariant : ''} ${PLACheckboxDesign ? classes.selectedSkuProduct : ''} ${(PLACheckboxDesign && brand?.code === 'FB') ? classes.brandColorBorder : ''}`}
                                value={sku.id}
                                id={`radio-button-${sku.id}`}
                                data-test="pdp-radio-button"
                                htmlFor={`product-sku ${sku.id}`}
                                name="pdpRadioButton"
                                label={(
                                    /*
                                The FoodRadioLabelContainer can be replaced with FoodRadioLabel component without changing anything else
                                The Container component is build to fetch the availability message for upsells.
                                This only acts like a layer over the SKUs and can be deleted / replaced in future easily when or if
                                findAvailability query is built in the aggregator.
                            */
                                    presentation_family === 'food' ? (
                                        <FoodRadioLabelContainer
                                            // eslint-disable-next-line no-underscore-dangle
                                            skuType={sku.__typename}
                                            classes={classes}
                                            product={product}
                                            isPassportBundleProduct={isPassportBundleProduct}
                                            productSku={sku}
                                            location={location}
                                            productUrl={productUrl}
                                            brand={brand}
                                            selectedSku={selectedSku}
                                            isPdpYotpoEnabled={isPdpYotpoEnabled}
                                            renderSkuPrice={renderSkuPrice}
                                            pricesList={pricesList?.length ? pricesList : null}
                                            floralPLARedesign={floralPLARedesign}
                                            ssrDeviceType={ssrDeviceType}
                                            isCyoProduct={isCyoProduct}
                                            isPdpRedesignEnabled={isPdpRedesignEnabled}

                                        />
                                    ) : (
                                        <FloralRadioLabelContainer
                                            sku={sku}
                                            isPassportBundleProduct={isPassportBundleProduct}
                                            isUpsellFlagAndABTestEnabled={isUpsellFlagAndABTestEnabled}
                                            showUpsellMessage={showUpsellMessage}
                                            pricesList={pricesList.length ? pricesList : []}
                                            floralPLARedesign={floralPLARedesign}
                                            isCurrentSkuAsUpsell={isCurrentSkuAsUpsell}
                                            priceDifferenceBetweenSkuAndUpsell={priceDifferenceBetweenSkuAndUpsell}
                                            productType={product?.availability?.productDeliveryType}
                                            renderSkuPrice={!isBot || isDynamicPricingEnabled ? !dynamicPriceIsLoading : true}
                                            isPdpRedesignEnabled={isPdpRedesignEnabled}
                                            productSkuPrices={productSkuPrices}
                                            isPlaRedesignEnabled={isPlaRedesignEnabled}
                                            isPlaRedesignVariantB={isPlaRedesignVariantB}

                                        />
                                    )
                                )}
                                onChange={!customizedRadio ? selectProduct : null}
                                classes={isFoodBrand ? { root: `${classes.formControlRoot} ${upsellRedesign ? classes.removeBorder : ''}`, label: classes.formControlLabel } : { label: classes.formLabel }}
                                control={(isPdpRedesignEnabled ? false : customizedRadio)
                                    ? (
                                        <Radio
                                            // eslint-disable-next-line no-underscore-dangle
                                            className={sku.__typename === 'Upsell' ? classes.rootUpsell : classes.root}
                                            checkedIcon={<span className={`${classes.icon} ${classes.checkedIcon}`} />}
                                            icon={<span className={classes.icon} />}
                                            inputProps={{
                                                label: `product-sku ${sku.id}`,
                                                id: `product-sku ${sku.id}`,
                                            }}
                                            classes={{
                                                root: `${PLARedesignVariant ? classes.hideRadio : classes.radio}`,
                                                checked: classes.checked,
                                            }}
                                            onClick={(e) => {
                                                tracker(sku);

                                                // eslint-disable-next-line no-underscore-dangle
                                                if (sku?.__typename === 'Upsell' && isFoodBrand) {
                                                    const eventParam = {
                                                        eventCategory: 'PDP Upsell',
                                                        eventAction: 'Default Upsell clicked',
                                                        eventLabel: sku?.id || '',
                                                    };
                                                    trackEvent(eventParam);
                                                    redirectToSku(e, sku);
                                                }
                                            }}
                                            checked={selectedSku.id === sku.id}
                                        />
                                    )
                                    : (
                                        <Radio
                                            inputProps={{
                                                label: `product-sku ${sku.id}`,
                                                id: `product-sku ${sku.id}`,
                                                name: 'radio-buttons',
                                                'aria-label': sku?.name,
                                            }}
                                            size={isPdpRedesignEnabled ? 'small' : 'medium'}
                                            classes={{
                                                root: `${PLARedesignVariant ? classes.hideRadio : classes.radio}`,
                                                checked: classes.checked,
                                            }}
                                            onClick={() => {
                                                tracker(sku);
                                            }}
                                            checked={selectedSku.id === sku.id}
                                        />
                                    )}
                            />
                        )}
                    </RedirectToSku>
                );
            })}
        </RadioGroup>
    );

    const renderSingleSkuLayout = () => (skus).map((sku) => {
        const pricesList = dynamicPriceList(sku);
        return (
            !hidePrice && (
                <ProductPriceName
                    pricesList={pricesList}
                    getRetailPrice={getRetailPrice}
                    getSalePrice={getSalePrice}
                    sku={sku}
                    product={product}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    selectedSku={selectedSku}
                    productUrl={productUrl}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                />
            )

        );
    });

    const renderSkuSection = (sku) => {
        const pricesList = dynamicPriceList(skus?.find?.((item) => item?.id === sku?.id));
        return (
            !hidePrice && (
                <ProductPriceName
                    pricesList={pricesList}
                    getRetailPrice={getRetailPrice}
                    getSalePrice={getSalePrice}
                    sku={sku}
                    product={product}
                    isPdpRedesignEnabled={isPdpRedesignEnabled}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                />
            )
        );
    };
    const getSelectedCyoProduct = () => <SelectedGiftSize skuData={skus} selectProduct={selectProduct} selectedSku={selectedSku} renderSkuPrice={renderSkuPrice} />;

    const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
    const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';
    const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
    const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;

    const isPmallProduct = featureFlags['is-pmall-pdp-template-enabled']  && (product?.brandId === '1030' || product?.brandId === '1033') && (isPmallPersonalizationEnabled || pmallPersonalizationType);
    const renderSkuYotpo = () => (
        <div className={classes.gridContainer}>
            <YotpoProductReview
                product={product}
                selectedSku={selectedSku}
                productUrl={productUrl} // comes off content from 2 levels up
                skuEnabledOnMobile
                isStandardPdp
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
            <div className={classes.productSku}>{getBaseCode(selectedSku.id, true)}</div>
        </div>
    );
    const renderSkuProductReview = () => (
        <div className={classes.gridContainer}>
            <ProductReview
                product={product}
                selectedSku={selectedSku}
                productUrl={productUrl} // comes off content from 2 levels up
                skuEnabledOnMobile
                isStandardPdp
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
            <div className={classes.productSku}>{getBaseCode(selectedSku.id, true)}</div>
        </div>
    );

    const getSkuLayout = () => {
        if (upsellRedesign && skus.length === 1 && !isPmallProduct) {
            return renderSingleSkuLayout();
        }
        if ((skus.length > 1 && isPmallProduct) || !isPmallProduct) {
            return (
                <>
                    {isPdpRedesignEnabled && presentation_family === 'food' && featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-pdp-yotpo-enabled'] && renderSkuYotpo()}
                    {isPdpRedesignEnabled && presentation_family === 'food' && featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-power-review-enabled'] && renderSkuProductReview()}
                    {getRadioButtons()}
                    {!caTotalPriceTest && <PriceBreakDownUi dynamicPriceData={productSkuPrices.length > 0 ? productSkuPrices.find((item) => selectedSku.id === item.id) : null} popperPosition="right" isPdpRedesignEnabled={isPdpRedesignEnabled} isCaDelivery={isCaDelivery} />}
                </>
            );
        }
        return '';
    };

    const defaultAttributes = (attributes) => {
        const defAttributes = {
            net_weight: {
                item: [],
            },
            quality_grade: {
                item: [],
            },
            count: {
                item: [],
            },
            wine_beer_type: {
                item: [],
            },
        };

        /**
         * Getting unique values and creating list of default values
         */
        (Object.keys(attributes || {})).forEach((skuKey) => {
            if (!defAttributes?.net_weight.item?.includes?.(attributes[skuKey].net_weight) && attributes[skuKey].net_weight) {
                defAttributes.net_weight.item.push(attributes[skuKey].net_weight);
            }
            if (!defAttributes?.quality_grade.item?.includes?.(attributes[skuKey].quality_grade) && attributes[skuKey].quality_grade) {
                defAttributes.quality_grade.item.push(attributes[skuKey].quality_grade);
            }
            if (!defAttributes?.count.item?.includes?.(attributes[skuKey].count) && attributes[skuKey].count) {
                defAttributes.count.item.push(attributes[skuKey].count);
            }
            if (!defAttributes?.wine_beer_type.item?.includes?.(attributes[skuKey].wine_beer_type) && attributes[skuKey].wine_beer_type) {
                defAttributes.wine_beer_type.item.push(attributes[skuKey].wine_beer_type);
            }
        });

        /**
         * Sorting
         */
        (Object.keys(defAttributes || {})).forEach((key) => {
            defAttributes[key].item.sort((a, b) => a - b);
        });

        return defAttributes;
    };

    if (productNameRender && !isPmallProduct) {
        const pricesList = dynamicPriceList(selectedSku);
        return (
            <>
                {!isPdpRedesignEnabled
                && (
                    <ProductNameRender
                        product={product}
                        selectedSku={selectedSku}
                        isPassportBundleProduct={isPassportBundleProduct || {}}
                        flagIsAvailableToShipNow={featureFlags['is-available-to-ship-now']}
                        flagIsDeliveryMessageNextVariant={featureFlags['is-delivery-message-next-variant']}
                        pricesList={pricesList}
                        getRetailPrice={getRetailPrice}
                        getSalePrice={getSalePrice}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                    />
                )}
                {presentation_family === 'food' && !hideUpsells && ((showSkuOnMobile && !isPlaFood && !isPdpRedesignEnabled) || isPlaRedesignEnabled) && (
                    <Media
                        query="(max-width: 767px)"
                    >
                        {(matches) => (matches ? (
                            <>
                                {upsells.length > 0 && (
                                    <Upsells
                                        upsells={upsells}
                                        location={location}
                                        brandName={product?.brand}
                                        product={product}
                                        productUrl={productUrl}
                                        brand={brand}
                                        renderSkuPrice={renderSkuPrice}
                                        selectedSku={selectedSku}
                                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                                    />
                                )}
                            </>
                        ) : (<></>))}
                    </Media>
                )}

            </>
        );
    }
    if (isPdpRedesignEnabled && skus.length > 1 && presentation_family === 'food' && isPdpRedesignSkuEnabled) {
        return (
            <PDPSkuSelector
                skuData={skus}
                selectProduct={selectProduct}
                selectedSku={selectedSku}
                renderSkuPrice={renderSkuPrice}
                dynamicPriceList={dynamicPriceList}
                productUrl={productUrl}
                product={product}
                isPdpRedesignEnabled={isPdpRedesignEnabled}
            />
        );
    }
    if (byoPdpEnabled && experimentByoRedesign === 'variant' && product?.productType === 'CUSTOM_ASSORTMENT') {
        return getSelectedCyoProduct();
    }
    return (
        <>
            <FoodConfigurator
                handleSkuChange={handleSkuChange}
                selectedSku={selectedSku}
                product={product}
                attributes={syAttributes}
                isSyConfigurator={isSyConfigurator} // will return child directly if the flag is disabled!
                defaultAttributes={defaultAttributes(skuSpecific) || skuAttributes}
                skuAttributes={skuSpecific}
                renderSingleSkuLayout={renderSkuSection(selectedSku || skus?.[0])}
                attributesWatchList={attributesWatchList}
                brandCode={product?.brandId || ''}
            >
                {featureFlags['is-sku-dropdown-enabled'] && skuData.length >= 4 && dropDownBrand ? (
                    <FloralDropDownContainer
                        skuDataList={skus}
                        selectedSku={selectedSku}
                        selectProduct={selectProduct}
                        presentationFamily={presentation_family}
                        dynamicPriceList={dynamicPriceList}
                    />
                ) : (
                    <>
                        {product?.baseCode && isPmallProduct && !isSkuShown && <span className={classes.baseCode}>Item # {product.baseCode}</span>}
                        {getSkuLayout()}
                    </>
                )}
            </FoodConfigurator>
            {(!hideUpsells && ((!isPlaFood &&  !isPdpRedesignEnabled) || isPlaRedesignEnabled))
                && (
                    <>
                        {upsells.length > 0 && (
                            <Upsells
                                upsells={upsells}
                                location={location}
                                brandName={product?.brand}
                                product={product}
                                productUrl={productUrl}
                                brand={brand}
                                renderSkuPrice={renderSkuPrice}
                                selectedSku={selectedSku}
                                isPdpRedesignEnabled={isPdpRedesignEnabled}
                                isPlaRedesignEnabled={isPlaRedesignEnabled}
                            />
                        )}
                        {!isFoodBrand && !isPdpRedesignEnabled && (
                            <KlarnaCreditPromotionBadge
                                selectedSku={selectedSku}
                                productSkuPrices={productSkuPrices}
                            />
                        )}
                    </>
                )}
        </>
    );
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
    activeABTests: getActiveABTests(state),
    enterpriseId: getEnterpriseId(state),
    isBot: getIsBot(state),
    userSubmittedProductFilterZipcode: getUserSubmittedProductFilterZipcode(state),
});

const mapDispatchToProps = {
    trackEvent: tagManagerActions.trackEvent,
};

CommonRadioGroup.defaultProps = {
    renderSkuPrice: () => { },
    skuMonths: {},
    clubUpsells: [],
    changeClubMonth: () => { },
    changeClubLength: () => { },
    customizedRadio: false,
    productType: null,
    selectedClubUpsells: null,
    changeClubUpsell: () => { },
    baseProductSku: null,
    isPassportBundleProduct: {},
    isPdpYotpoEnabled: false,
    productUrl: '',
    activeABTests: {},
    productNameRender: false,
    clubComponents: {},
};

CommonRadioGroup.propTypes = {
    classes: object.isRequired,
    trackEvent: func.isRequired,
    userSubmittedProductFilterZipcode: string.isRequired,
    parentPartNumber: string,
    skuData: skuDataType.isRequired,
    handleSkuChange: func.isRequired,
    selectedSku: selectedSkuType.isRequired,
    presentation_family: string.isRequired,
    customizedRadio: bool,
    renderSkuPrice: func,
    changeClubMonth: func,
    productType: string,
    skuMonths: object,  // will replace with shape method once club GQL ready
    changeClubLength: func,
    clubUpsells: array,  // will replace with shape method once club GQL ready
    selectedClubUpsells: string,
    changeClubUpsell: func,
    baseProductSku: skuDataType,
    isPassportBundleProduct: shape({
        prices: shape({
            value: number,
        }),
        enable: bool,
    }),
    product: productPropType.isRequired,
    location: shape({
        state: shape({
            categoryId: string,
            categoryName: string,
        }),
    }).isRequired,
    productUrl: string,
    brand: shape({
        domain: string,
    }).isRequired,
    isPdpYotpoEnabled: bool,
    activeABTests: object,
    enterpriseId: string.isRequired,
    isBot: bool.isRequired,
    floralPLARedesign: string,
    ssrDeviceType: string,
    upsellRedesign: bool,
    productNameRender: bool,
    showSkuOnMobile: bool,
    isDynamicPrice: bool,
    isSkuShown: bool,
    clubComponents: object,
    setShippingModalOpen: bool,
    isClubPDPV2: bool,
    isCyoProduct: bool,
    isPdpRedesignEnabled: bool,
    isPdpRedesignSkuEnabled: bool,
    isPlaRedesignEnabled: bool,
    hideUpsells: bool,
    hidePrice: bool,
    isPlaRedesignVariantB: bool,
};
CommonRadioGroup.defaultProps = {
    parentPartNumber: '',
    floralPLARedesign: '',
    ssrDeviceType: '',
    upsellRedesign: false,
    showSkuOnMobile: false,
    isDynamicPrice: false,
    isSkuShown: false,
    setShippingModalOpen: false,
    isClubPDPV2: false,
    isCyoProduct: false,
    isPdpRedesignEnabled: false,
    isPdpRedesignSkuEnabled: false,
    isPlaRedesignEnabled: false,
    hideUpsells: false,
    hidePrice: false,
    isPlaRedesignVariantB: false,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CommonRadioGroup));
